'use client';

import { SessionProvider } from 'next-auth/react';
import { AuthProvider } from '@/contexts/AuthContext';

export function Providers({
  children,
  yandexAuthEnabled,
  yandexClientId,
}: {
  children: React.ReactNode;
  yandexAuthEnabled: boolean;
  yandexClientId: string | null;
}) {
  return (
    <SessionProvider>
      <AuthProvider yandexAuthEnabled={yandexAuthEnabled} yandexClientId={yandexClientId}>
        {children}
      </AuthProvider>
    </SessionProvider>
  );
}
